var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.1668H6C2.38 15.1668 0.833328 13.6202 0.833328 10.0002V6.00016C0.833328 2.38016 2.38 0.833496 6 0.833496H10C13.62 0.833496 15.1667 2.38016 15.1667 6.00016V10.0002C15.1667 13.6202 13.62 15.1668 10 15.1668ZM6 1.8335C2.92666 1.8335 1.83333 2.92683 1.83333 6.00016V10.0002C1.83333 13.0735 2.92666 14.1668 6 14.1668H10C13.0733 14.1668 14.1667 13.0735 14.1667 10.0002V6.00016C14.1667 2.92683 13.0733 1.8335 10 1.8335H6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83999 10.8534C8.71333 10.8534 8.58666 10.8068 8.48666 10.7068L6.13333 8.35344C5.93999 8.1601 5.93999 7.8401 6.13333 7.64677L8.48666 5.29344C8.67999 5.1001 8.99999 5.1001 9.19333 5.29344C9.38666 5.48677 9.38666 5.80677 9.19333 6.0001L7.19333 8.0001L9.19333 10.0001C9.38666 10.1934 9.38666 10.5134 9.19333 10.7068C9.09999 10.8068 8.97333 10.8534 8.83999 10.8534Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.b10fd3c9406d445dcd601d8ff56db242.svg";
export { ForwardRef as ReactComponent };